import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.mutableDialogSwitch,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mutableDialogSwitch) = $event)),
    "onClick:outside": _ctx.closeDialog,
    transition: "dialog-top-transition",
    width: "auto",
    scrollable: "",
    "retain-focus": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "secondary",
            elevation: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Create A Participant", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "mdi-close-outline",
                density: "comfortable",
                variant: "plain",
                onClick: _ctx.closeDialog
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_card_text, { class: "mt-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, { ref: "creationForm" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationResults }, null, 8, ["validation-results"]),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.participantObject.firstName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.participantObject.firstName) = $event)),
                            label: "First Name",
                            required: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.participantObject.middleName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.participantObject.middleName) = $event)),
                            label: "Middle Name"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.participantObject.lastName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.participantObject.lastName) = $event)),
                            label: "Last Name",
                            required: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.participantObject.ssn,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.participantObject.ssn) = $event)),
                            label: "Social Security Number",
                            maxlength: "9",
                            counter: "",
                            "append-inner-icon": _ctx.showssn ? 'mdi-eye' : 'mdi-eye-off',
                            type: _ctx.showssn ? 'text' : 'password',
                            "onClick:appendInner": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showssn = !_ctx.showssn))
                          }, null, 8, ["modelValue", "append-inner-icon", "type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            items: _ctx.genderSelectOptions,
                            "item-value": "id",
                            "item-title": "description",
                            modelValue: _ctx.participantObject.genderId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.participantObject.genderId) = $event)),
                            label: "Sex",
                            required: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["items", "modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.participantObject.dateOfBirth,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.participantObject.dateOfBirth) = $event)),
                            label: "Date Of Birth",
                            type: "date",
                            required: "",
                            rules: _ctx.requiredFieldRules
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.currentUser && _ctx.currentUser?.attachedPrograms.length > 1)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-subtitle-2" }, "Our records indicate that you are a part of several treatment programs. Please select which treatment program this participant should be associated with.", -1)),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.participantObject.treatmentProgramId,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.participantObject.treatmentProgramId) = $event)),
                                items: _ctx.currentUser.attachedPrograms,
                                "item-value": "treatmentProgramId",
                                "item-title": "description",
                                label: "Select Desired Program",
                                required: "",
                                rules: _ctx.requiredFieldRules
                              }, null, 8, ["modelValue", "items", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            color: "secondary",
                            label: "Proceed to participant after creation?",
                            modelValue: _ctx.isGettingRedirected,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isGettingRedirected) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "justify-start" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "success",
                onClick: _ctx.submitParticipant,
                disabled: _ctx.createButtonDisabled
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("Create Participant", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"])), [
                [_directive_ripple]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "secondary",
                onClick: _ctx.clearForm
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Clear Form", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_ripple]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                color: "error",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Close Window", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}